// extracted by mini-css-extract-plugin
export default {"buttonFooter":"ButtonFotter_buttonFooter__hqBXr"};